import { useState, useEffect } from "react";

const slides = [
  {
    src: "https://storage.readdy-site.link/project_files/26e3b86f-cc28-43d6-ae72-d910dd967b3f/29c4222d-5749-46f6-9496-7178149cfbc7_1-2.png?v=8fd47a1ee0ea63772ce18c310ae60510",
  },
  {
    src: "https://storage.readdy-site.link/project_files/26e3b86f-cc28-43d6-ae72-d910dd967b3f/8dd51d2e-01d3-4c5d-9224-e35bb341aebe_3.png?v=d119aec4ab49fa7e70a0fb03961a6ea6",
  },
  {
    src: "https://storage.readdy-site.link/project_files/26e3b86f-cc28-43d6-ae72-d910dd967b3f/e1574bae-180e-48c8-931d-662825f02e09_4.png?v=5505f431003ab2e27ed5782377e85233",
  },
];

const tickerItems = [
  "ヘルパーステーションみりん、訪問介護・障害福祉サービス受付中。お気軽にご相談ください。",
];

export default function Hero() {
  const [current, setCurrent] = useState(0);
  const [loaded, setLoaded] = useState(false);
  const [textVisible, setTextVisible] = useState(false);

  useEffect(() => {
    const t1 = setTimeout(() => setLoaded(true), 100);
    const t2 = setTimeout(() => setTextVisible(true), 600);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, []);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  return (
    <section className="relative w-full h-screen overflow-hidden">
      {slides.map((slide, i) => (
        <div
          key={i}
          className={`absolute inset-0 transition-opacity ${i === current ? "opacity-100" : "opacity-0"}`}
          style={{ transitionDuration: "1500ms" }}
        >
          <img
            src={slide.src}
            alt=""
            className={`w-full h-full object-cover object-top transition-transform ${i === current ? "scale-105" : "scale-100"}`}
            style={{ transitionDuration: "6000ms", transitionTimingFunction: "ease-out" }}
          />
        </div>
      ))}

      <div className="absolute inset-0 bg-gradient-to-r from-black/40 via-black/10 to-transparent"></div>

      {/* Copy Text — left side, vertical layout */}
      <div className="absolute inset-0 flex flex-col justify-center pl-8 md:pl-20 pb-16">
        <div
          style={{
            opacity: textVisible ? 1 : 0,
            transform: textVisible ? "translateX(0)" : "translateX(-30px)",
            transition: "opacity 1s ease, transform 1s ease",
          }}
        >
          <div className="w-10 h-0.5 bg-[#3ab5c6] mb-6"
            style={{ width: textVisible ? "40px" : "0px", transition: "width 0.8s ease 0.3s" }}
          ></div>
          <p
            className="text-white/80 text-xs font-['Poppins'] tracking-[0.3em] mb-4 uppercase"
            style={{
              opacity: textVisible ? 1 : 0,
              transition: "opacity 0.8s ease 0.2s",
            }}
          >
            愛知県刈谷市から、地域社会へ
          </p>
          <h1
            className="text-3xl md:text-5xl font-bold text-white leading-tight tracking-wide mb-6"
            style={{
              opacity: textVisible ? 1 : 0,
              transform: textVisible ? "translateY(0)" : "translateY(15px)",
              transition: "opacity 0.9s ease 0.4s, transform 0.9s ease 0.4s",
            }}
          >
            人と地域をつなぎ、<br />
            より良い未来を創造する
          </h1>
          <p
            className="text-white/70 text-sm max-w-xs leading-relaxed"
            style={{
              opacity: textVisible ? 1 : 0,
              transition: "opacity 0.8s ease 0.7s",
            }}
          >
            株式会社FDは、介護福祉事業を起点に、地域に根ざした様々なサービスを提供しています。人々の暮らしに寄り添い、持続可能な社会づくりに貢献します。
          </p>
        </div>
      </div>

      {/* Slide indicator — vertical right side */}
      <div
        className="absolute right-8 top-1/2 -translate-y-1/2 flex flex-col gap-3"
        style={{ opacity: loaded ? 1 : 0, transition: "opacity 0.8s ease 1s" }}
      >
        {slides.map((_, i) => (
          <button
            key={i}
            onClick={() => setCurrent(i)}
            className={`rounded-full transition-all duration-500 cursor-pointer ${
              i === current ? "bg-[#3ab5c6] h-8 w-1.5" : "bg-white/50 h-2 w-1.5"
            }`}
          />
        ))}
      </div>

      {/* News Ticker */}
      <div
        className="absolute bottom-0 left-0 w-full bg-white/95 border-t border-gray-100"
        style={{
          opacity: loaded ? 1 : 0,
          transform: loaded ? "translateY(0)" : "translateY(100%)",
          transition: "opacity 0.6s ease 1.2s, transform 0.6s ease 1.2s",
        }}
      >
        <div className="max-w-[1240px] mx-auto px-6 py-3 flex items-center gap-4 overflow-hidden">
          <span className="text-[#3ab5c6] text-xs font-bold whitespace-nowrap border border-[#3ab5c6] px-3 py-1 rounded-full shrink-0">
            お知らせ
          </span>
          <div className="overflow-hidden flex-1">
            <div className="flex gap-16 whitespace-nowrap" style={{ animation: "ticker 28s linear infinite" }}>
              {[...tickerItems, ...tickerItems].map((item, i) => (
                <span key={i} className="text-sm text-gray-700 whitespace-nowrap">{item}</span>
              ))}
            </div>
          </div>
          <a href="#contact" className="ml-auto text-[#3ab5c6] text-lg cursor-pointer whitespace-nowrap shrink-0">›</a>
        </div>
      </div>

      <style>{`
        @keyframes ticker {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
      `}</style>
    </section>
  );
}
